import React from 'react';
import styled from 'styled-components/macro';
import { Search, Dropdown } from 'lib/components';

import { VerificationStatusOptions } from 'lib/const/VerificationsStatusOptions';
import {
  CustomerOption,
  CustomersDropdown,
} from '../../components/CustomersDropdown';
import { Flex } from 'lib/components/styles/layout';
import { ButtonWithTableFieldsModal } from 'lib/components/buttonWithTableFieldsModal';
import { Field } from 'lib/components/modal/ModalCustomTableFields/types';

type FilterProps = {
  marginRight?: number;
  width?: number;
};
export const Filter = styled.div<FilterProps>`
  min-width: 224px;
  width: ${props => `${props.width}px` || 'auto'};
  margin-right: ${props => `${props.marginRight}px` || '0px'};
`;

type Props = {
  prevSearch?: string;
  statusFilter?: number;
  customerFilter?: number;
  showCustomerFilter: boolean;
  onSelectStatus(statusValue: number): void;
  onSelectCustomer(option: CustomerOption): void;
  onSearch(search: string): void;
  setCustomersLength?: (value: number) => void;
  allFields: Field[];
  onSaveCustomTableFields: (selected: Field[]) => void;
  defaultReports: Field[];
  setReports: React.Dispatch<React.SetStateAction<Field[]>>;
  reports: Field[];
};

const tableName = 'SuperAdminUsers';
export const SearchAndFilter = ({
  prevSearch,
  statusFilter,
  customerFilter,
  showCustomerFilter,
  onSelectStatus,
  onSelectCustomer,
  onSearch,
  setCustomersLength,
  allFields,
  onSaveCustomTableFields,
  defaultReports,
  setReports,
  reports,
}: Props) => {
  return (
    <Flex
      alignItems='center'
      width='100%'
      justifyContent='space-between'
      margin='0 0 24px 0'
      flexWrap='nowrap'
      flexDirection='row'
      gap='12px'
    >
      <Search
        placeholder='Search by name, customer or email...'
        onSearch={onSearch}
        prevSearch={prevSearch}
        width='536px'
      />

      <Dropdown
        height={40}
        creatable={false}
        className='dropdown'
        placeholder={'Filter by Statuses'}
        zIndexProp={1}
        value={VerificationStatusOptions.find(
          option => option.value === statusFilter
        )}
        width={224}
        onChange={value => onSelectStatus(value.value)}
        options={VerificationStatusOptions}
      />

      {showCustomerFilter && (
        <CustomersDropdown
          showAllCustomersOption={true}
          customerFilter={customerFilter}
          onSelectCustomer={onSelectCustomer}
          zIndexProp={1}
          setCustomersLength={setCustomersLength}
          width={224}
        />
      )}

      <ButtonWithTableFieldsModal
        setReports={setReports}
        reports={reports}
        allFields={allFields}
        defaultReports={defaultReports}
        onUpdateClick={onSaveCustomTableFields}
        maxFieldConfig={{ count: 6 }}
        storageKey={tableName}
      />
    </Flex>
  );
};
